import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiServiceService } from './api-service.service';
import { from } from 'rxjs';
// @Injectable({
//   providedIn: 'root'
// })
// export class CartService {
//   private addToCartSource = new Subject<string>();
//   addToCart$ = this.addToCartSource.asObservable();

//   triggerAddToCart(productId: string) {
//     console.log('CartService received productId:', productId);
//     this.addToCartSource.next(productId);
//   }
// }

@Injectable({ providedIn: 'root' })
export class CartService {
  constructor(private api: ApiServiceService) {}

  addToCart(param: any) {
    // param = { product_id, size, quantity, user_id, seller_id, variantData, attributeSize, selectedSizeData }
    return from(this.api.addToCart(param)); // converts promise to observable
  }
}

